<div *ngIf="!hidePie"
  class="d-flex align-items-center me-4">
  <div class="me-3">
    <yc-pie-chart
      [height]="106"
      [width]="160"
      [labels]="labels"
      [data]="data"
      [backgroundColors]="backgroundColors"
      [chartOptions]="chartOptions">
    </yc-pie-chart>
  </div>
  <yc-chart-legend
    [legendData]="legendData">
  </yc-chart-legend>
</div>
